import type { Step } from "react-joyride";

export const otPlaceholderTourSteps: Step[] = [
  {
    target: "body",
    content: "ຫນ້ານີ້ໃຊ້ກັບຄືນໄປລາຍການຂໍ້ກຳນົດ OT ຫຼື ຄຳຂໍ OT ເມື່ອຟອມຍັງບໍ່ພ້ອມ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="ot-placeholder-back"]',
    content: "ກົດກັບຄືນເພື່ອໄປຫນ້າລາຍການທີ່ກ່ຽວຂ້ອງ.",
    placement: "bottom",
  },
];
